import IAuthDomain from 'app/business-logic/domain-models/IAuthDomain';

export const getPreferredFacilityFromUrl = (): Required<IAuthDomain> | null => {
  const [companyAlias, facilityAlias] = window.location.pathname.split('/').filter(Boolean);
  if (!companyAlias || !facilityAlias) return null;
  return { companyAlias, facilityAlias };
};
